import React from 'react';
import { Card, CardContent, CardHeader } from '../../components/ui/card';
import { ChevronDown } from 'lucide-react';

export function TestScheduleSkeleton() {
    return (
        <Card className="shadow-none fixed right-0 bottom-0 w-full md:w-[320px] h-screen py-0 bg-[var(--q3-surface-dim)] z-10 border-l-2 border-r-0 flex flex-col animate-pulse">
            <CardHeader className="flex flex-row items-center justify-between py-3 border-b-2 px-3 bg-[var(--q3-surface-dim)] sticky top-0 z-10">
                <div className="flex gap-2 items-center">
                    <div className="h-7 w-56 bg-[var(--q3-surface-dimmer)] rounded-md"></div>
                </div>
                <div className="bg-[var(--q3-surface-dimmer)] rounded-full p-1">
                    <ChevronDown size={18} className="text-gray-300" />
                </div>
            </CardHeader>
            <CardContent className="flex-1 overflow-y-scroll px-4 pt-4">
                {/* Filter Badges Skeleton */}
                <div className="flex gap-2 mb-4 overflow-x-auto py-2">
                    <div className="h-8 w-24 bg-[var(--q3-surface-dimmer)] rounded-full"></div>
                    <div className="h-8 w-20 bg-[var(--q3-surface-dimmer)] rounded-full"></div>
                    <div className="h-8 w-28 bg-[var(--q3-surface-dimmer)] rounded-full"></div>
                </div>

                {/* Live Item Skeleton */}
                <div className="mb-4">
                    <div className="flex mb-3">
                        <div className="w-11 h-13 bg-[var(--q3-surface-dimmer)] rounded-lg mr-3"></div>
                        <div className="flex-1 bg-[var(--q3-surface-default)] rounded-lg p-3">
                            <div className="h-4 w-2/3 bg-[var(--q3-surface-dimmer)] rounded-md mb-2"></div>
                            <div className="h-24 w-full bg-[var(--q3-surface-dimmer)] rounded-md mb-3"></div>
                            <div className="h-10 w-full bg-[var(--q3-surface-dimmer)] rounded-md"></div>
                        </div>
                    </div>
                </div>

                {/* Monthly Items Skeleton */}
                <div>
                    <div className="flex items-center justify-between bg-[var(--q3-surface-dimmer)] p-4 rounded-lg mb-3">
                        <div className="h-6 w-32 bg-gray-300 rounded-md"></div>
                        <div className="h-6 w-16 bg-gray-300 rounded-full"></div>
                    </div>
                    {[1, 2, 3].map((i) => (
                        <div className="flex mb-3" key={i}>
                            <div className="w-12 h-18 bg-[var(--q3-surface-dimmer)] rounded-lg mr-3"></div>
                            <div className="flex-1 bg-[var(--q3-surface-default)] rounded-lg p-3">
                                <div className="h-4 w-3/4 bg-[var(--q3-surface-dimmer)] rounded-md mb-2"></div>
                                <div className="h-4 w-1/2 bg-[var(--q3-surface-dimmer)] rounded-md mb-3"></div>
                                <div className="h-4 w-1/3 bg-[var(--q3-surface-dimmer)] rounded-md"></div>
                            </div>
                        </div>
                    ))}
                </div>
            </CardContent>
        </Card>
    );
}